import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RootState, useAppSelector, useAppDispatch, loadUsers } from '../../../redux';
import { RoutineAction, User } from '../../../models';
import { Select } from '../../Select';
import type { Value } from '../../Select';
import { Icon } from '../../Icon';

interface AssignFormProps {
    action: RoutineAction;
    onSave?: (action: RoutineAction) => void;
}

function AssignForm(props: AssignFormProps) {
    const { action, onSave } = props;
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [options, setOptions] = useState<AnyObj>(action.options || {});
    const { users } = useAppSelector((state: RootState) => state.users);

    useEffect(() => { dispatch(loadUsers()); }, [dispatch]);
    useEffect(() => { onSave && onSave({ ...action, options }); }, [options]);

    const userOptions = (users || [])
        .sort((a: User, b: User) => a.fullname().localeCompare(b.fullname()))
        .map((user: User) => ({
            value: user._id,
            label: user.fullname(),
            leftContent: <Icon type="user" color="gray-600" className="ml-3 inline" />
        }));

    return (
        <div className="grid grid-cols-1 xl:grid-cols-4 gap-2 bg-purple-50 dark:bg-purple-950/30 p-2 border rounded w-full">
            <label className="text-sm col-span-1">{t('projects.routine.action.change_assignee')}</label>
            <div className="col-span-3">
                <Select
                    defaultValue={options.assignee as Value}
                    options={userOptions}
                    onChange={(assignee: any) => setOptions({ ...options, assignee })}
                    className="border rounded border-gray-300 dark:border-gray-600 w-full"
                    placeholder={t('projects.routine.action.change_assignee') || ''}
                />
            </div>
        </div>
    );
}

export default AssignForm;
